// extracted by mini-css-extract-plugin
export var container = "important-links-module--container--58e82";
export var text = "important-links-module--text--82200";
export var title = "important-links-module--title--34f4e";